export default __webpack_public_path__ + "static/media/family_whole_bw.87e19e90.jpg";